import React from 'react'

import InlineTextField from '../components/InlineTextField';

export class IposConfiguration extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            isEditing: false,
            origUsername: props.username,
            username: props.username,
            password: ''
        };
        this.edit = this.edit.bind(this);
        this.cancel = this.cancel.bind(this);
        this.changeUsername = this.changeUsername.bind(this);
        this.changePassword = this.changePassword.bind(this);
        this.commit = this.commit.bind(this);
    }

    edit() {
        this.setState({isEditing: true})
    }

    cancel() {
        this.setState({isEditing: false, username: this.state.username});
    }

    changeUsername(event) {
        this.setState({username: event.target.value});
    }

    changePassword(event) {
        this.setState({password: event.target.value});
    }

    commit() {
        this.props.onCommit(this.state.username, this.state.password);
        this.setState({isEditing: false});
    }

    render() {
        if (this.state.isEditing) {
            return (
                <tr>
                    <td>{this.props.retailerName}</td>
                    <td>{this.props.retailerGln}</td>
                    <td><input type="text" value={this.state.username} name="username" className="form-control" style={{fontSize: 'small', padding: '0.5rem 0.25rem'}} onChange={this.changeUsername}/></td>
                    <td><input type="password" value={this.state.password} name="password" className="form-control" style={{fontSize: 'small', padding: '0.5rem 0.25rem'}} onChange={this.changePassword}/></td>
                    <td>
                        <button className="btn btn-success" style={{padding: '0.5rem 0.25rem'}} onClick={this.commit}><i className="fa fa-check"/>&nbsp;</button>
                        <button className="btn btn-secondary" style={{padding: '0.5rem 0.25rem'}}  onClick={this.cancel}><i className="fa fa-times" />&nbsp;</button>
                    </td>
                    <td></td>
                </tr>
            )
        }
        return (
            <tr>
                <td>{this.props.retailerName}</td>
                <td>{this.props.retailerGln}</td>
                <td>{this.props.username}</td>
                <td>**********</td>
                <td><i className="fa fa-pencil-alt pull-right" onClick={this.edit}></i></td>
                <td>
                    <button type="button" className="btn btn-danger" title="löschen"
                            onClick={() => this.props.deleteIposConfiguration(this.props.retailerGln)}>
                        <i className="fa fa-trash"></i>
                    </button>
                </td>
            </tr>
        );

    }
}

export default IposConfiguration;



// WEBPACK FOOTER //
// ./src/admin/retailer/IposConfiguration.js